import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterContentChecked,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResizeObserver } from '@juggle/resize-observer';

const SOLUTION_ANIMATION_TIMEOUT = 50;

@Component({
  selector: 'lib-app-puzzle-solution-word-animation',
  templateUrl: './puzzle-solution-word-animation.component.html',
  styleUrls: ['./puzzle-solution-word-animation.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PuzzleSolutionWordAnimationComponent implements OnInit, AfterContentChecked {
  @ViewChild('solutionHidden', { static: true }) solutionHidden: ElementRef;
  @ViewChild('solutionContainer', { static: true }) solutionContainer: ElementRef;

  @Input() solutionWord: string;
  @Input() solutionOriginal: string;

  @Output() animationFinished = new EventEmitter<boolean>();

  public solutionOutput: string;

  public scaleValue: number;

  constructor(private el: ElementRef) {}

  // @HostListener('window:resize')
  private scale() {
    const childWidth = this.solutionHidden.nativeElement.offsetWidth;
    const containerWidth = this.solutionContainer.nativeElement.offsetWidth;
    this.scaleValue = Math.min(1, containerWidth / childWidth);
  }

  ngAfterContentChecked() {
    this.scale();
  }

  ngOnInit(): void {
    let time = 1000;

    if (this.solutionWord !== undefined) {
      this.animationFinished.emit(false);

      let index = 0;
      const solutionWord = this.solutionWord;
      this.solutionOutput = '';

      while (index < solutionWord.length) {
        const i = index;
        window.setTimeout(() => {
          this.solutionOutput += solutionWord[i];
        }, time);
        index++;
        time += SOLUTION_ANIMATION_TIMEOUT;
      }

      if (this.solutionOriginal === undefined) {
        window.setTimeout(() => {
          this.animationFinished.emit(true);
        }, time);
      }
    }

    if (this.solutionWord !== undefined && this.solutionOriginal !== undefined) {
      // window.setTimeout(() => {
      //   this.showOriginal = true;
      // }, 2000);

      window.setTimeout(() => {
        let solutionOriginal = this.solutionOriginal;
        let solutionWord = this.solutionWord.toUpperCase();

        const charsToAdd = [];
        const charsToReplace = [];

        let index = 0;

        while (solutionOriginal.length > 0) {
          const solutionWordChar = solutionWord[0];
          const solutionOriginalChar = solutionOriginal[0];

          if (solutionOriginalChar.toUpperCase() === solutionWordChar) {
            solutionWord = solutionWord.slice(1);
            solutionOriginal = solutionOriginal.slice(1);

            if (solutionOriginalChar !== solutionWordChar) {
              charsToReplace[index] = solutionOriginalChar;
            }
          } else {
            charsToAdd[index] = solutionOriginalChar;
            solutionOriginal = solutionOriginal.slice(1);
          }
          index++;
        }

        let addIndex = 0;
        let replaceIndex = 0;

        const animationInterval = window.setInterval(() => {
          if (addIndex < charsToAdd.length) {
            if (charsToAdd[addIndex] !== undefined) {
              this.solutionOutput =
                this.solutionOutput.slice(0, addIndex) + charsToAdd[addIndex] + this.solutionOutput.slice(addIndex);
            }
          }
          if (replaceIndex < charsToReplace.length) {
            if (charsToReplace[replaceIndex] !== undefined) {
              const newWordArray = this.solutionOutput.split('');
              newWordArray[replaceIndex] = charsToReplace[replaceIndex];
              this.solutionOutput = newWordArray.join('');
            }
          }

          if (addIndex >= charsToAdd.length && replaceIndex >= charsToReplace.length) {
            clearInterval(animationInterval);
            this.animationFinished.emit(true);
            return;
          }

          addIndex++;
          replaceIndex++;
        }, SOLUTION_ANIMATION_TIMEOUT);
      }, time + 1000);
    }

    const observer = new ResizeObserver((entries) => {
      this.scale();
    });
    observer.observe(this.el.nativeElement);
  }
}
